import { Outlet, useLocation } from 'react-router-dom'
import { TooltipProvider } from '@/components/ui/tooltip'
import { IconRail, MainSidebar } from './sidebar'
import { useSidebarShortcuts } from '@/hooks/useSidebarShortcuts'
import { useCinemaShortcuts } from '@/hooks/useCinemaShortcuts'
import { CinemaExitButton } from '@/components/cinema'
import { cn } from '@/lib/utils'

/** Pages that render fullbleed (no padding, no scroll) */
const FULLBLEED_SUFFIXES = ['/ramp', '/builder', '/schedule', '/cinematic']

export function AppLayout() {
  useSidebarShortcuts()
  useCinemaShortcuts()
  const { pathname } = useLocation()
  const isFullbleed = FULLBLEED_SUFFIXES.some((s) => pathname.endsWith(s))

  return (
    <TooltipProvider delayDuration={300}>
      <div className="flex h-screen w-full overflow-hidden bg-background text-sidebar-foreground">
        {/* Icon Rail (multi-location only, conditional) */}
        <IconRail />

        {/* Main Sidebar (3-state) */}
        <MainSidebar />

        {/* Content area — fullbleed pages get no padding/scroll so map resizes correctly */}
        <main
          className={cn(
            'relative flex-1',
            isFullbleed ? 'overflow-hidden' : 'overflow-auto p-4'
          )}
        >
          <Outlet />
        </main>

        {/* The one control that survives cinema mode. Rendered at the layout
            level so every page gets an escape hatch, not just the 3D views. */}
        <CinemaExitButton />
      </div>
    </TooltipProvider>
  )
}
